import React from "react";

//Company Section
const AboutUs = React.lazy(() => import("../pages/Company/AboutUs/AboutUs"));
const Services = React.lazy(() => import("../pages/Company/Services/Services"));
const Team = React.lazy(() => import("../pages/Company/Team/Team"));
const Pricing = React.lazy(() => import("../pages/Company/Pricing/Pricing"));
const PricingAPI = React.lazy(() => import("../pages/Company/Pricing/PricingAPI"));
const PrivacyAndPolicy = React.lazy(() => import("../pages/Company/PrivacyAndPolicy/PrivacyAndPolicy"));
const TermsAndConditions = React.lazy(() => import("../pages/Company/TermsAndConditions.js/TermsAndConditions"));
const Faqs = React.lazy(() => import("../pages/Company/Faqs/Faqs"));

//Contacts
const Contact = React.lazy(() => import("../pages/Contact/Contact"));

//Jobs Section
const JobGrid = React.lazy(() => import("../pages/Jobs/JobGrid/JobGrid"));
const JobDetails = React.lazy(() => import("../pages/Jobs/JobDetails/JobDetails"));

//Candidate and Company Section
const CandidateList = React.lazy(() => import("../pages/CandidateAndCompany/CandidateList/CandidateList"));
const CandidateDetails = React.lazy(() => import("../pages/CandidateAndCompany/CandidateDetails/CandidateDetails"));

//AuthPages
const ApiDoc = React.lazy(() => import("../pages/ApiDoc/ApiDoc"));

//Home Section
const Layout2 = React.lazy(() => import('../pages/Home/Layout2/Layout2'));
const HsCodeLinks = React.lazy(() => import("../pages/HsCodeAuto/HsCodeLinks"));

const userRoutes = [
  //Home Section
  { path: "/", component: <Layout2 /> },
  
  //HS Code
  { path: "/hs-code-details", component: <CandidateDetails /> },
  { path: "/hs-code-details/:product/:desc/:destination/:origin", component: <CandidateDetails /> },
  { path: "/hs-code-search", component: <CandidateList /> },

  //Regulations
  { path: "/regulation-details", component: <JobDetails /> },
  { path: "/regulation-search", component: <JobGrid /> },

  //Contact
  { path: "/contact", component: <Contact /> },

  // Api Doc
  { path: "/api-doc", component: <ApiDoc /> },

  // Sitemaps
  { path: "/sitemaps-hs-code-details/*", component: <HsCodeLinks /> },

  //Company Section
  { path: "/faqs", component: <Faqs /> },
  { path: "/privacyandpolicy", component: <PrivacyAndPolicy /> },
  { path: "/pricing", component: <Pricing /> },
  { path: "/pricingAPI", component: <PricingAPI /> },
  { path: "/team", component: <Team /> },
  { path: "/services", component: <Services /> },
  { path: "/aboutus", component: <AboutUs /> },

  { path: "tnc", component: <TermsAndConditions /> },
  { path: "privacy", component: <PrivacyAndPolicy /> },
];

export { userRoutes };
